<table [ngClass]="tableClass">
  <thead
    class="tw-border-0 tw-border-b-2 tw-border-solid tw-border-border-base tw-font-medium tw-text-muted"
  >
    <ng-content select="[header]"></ng-content>
  </thead>
  <tbody>
    <ng-container
      *ngTemplateOutlet="templateVariable().template; context: { $implicit: rows$ }"
    ></ng-container>
  </tbody>
</table>
